import PasswordRules from './PasswordRules';
import { isPasswordValid } from './password';
import { isPersonalEmailDomain } from './emailDomain';

export default function SignupForm({
    firstName,
    lastName,
    email,
    password,
    confirmPassword,
    company,
    terms,
    onChange,
    onSubmit,
    error,
    onShowLogin
}) {
    const personalEmail = isPersonalEmailDomain(email);
    const passwordsMatch = password.length > 0 && password === confirmPassword;
    const canSubmit = isPasswordValid(password) && passwordsMatch && terms && (!personalEmail || (company || '').trim());

    return (
        <>
            <h1>Create your account</h1>
            <p className="auth-subtitle">
                {personalEmail
                    ? 'Request access to an existing organization.'
                    : 'The first person on a company email domain becomes the organization admin.'}
            </p>

            <form onSubmit={onSubmit} className="auth-form">
                <div className="auth-name-row">
                    <input type="text" className="input-field" placeholder="First name" value={firstName} onChange={e => onChange('firstName', e.target.value)} required />
                    <input type="text" className="input-field" placeholder="Last name" value={lastName} onChange={e => onChange('lastName', e.target.value)} required />
                </div>
                <input type="email" className="input-field" placeholder="you@company.com" value={email} onChange={e => onChange('email', e.target.value)} required />
                {personalEmail && (
                    <input
                        type="text"
                        className="input-field"
                        placeholder="Company / Organization"
                        value={company}
                        onChange={e => onChange('company', e.target.value)}
                        required
                    />
                )}
                <div className="auth-password-fields">
                    <input type="password" className="input-field" placeholder="Choose a password" value={password} onChange={e => onChange('password', e.target.value)} required />
                    <input type="password" className="input-field" placeholder="Confirm password" value={confirmPassword} onChange={e => onChange('confirmPassword', e.target.value)} required />
                    <PasswordRules password={password} confirmPassword={confirmPassword} />
                </div>

                <label className="auth-terms">
                    <input type="checkbox" checked={terms} onChange={e => onChange('terms', e.target.checked)} />
                    <span>
                        I agree to the{' '}
                        <a href="/terms" target="_blank" rel="noopener noreferrer">Terms of Service</a>
                        {' '}*
                    </span>
                </label>

                {error && <div className="auth-error"><i className="fa-solid fa-triangle-exclamation"></i>{error}</div>}

                <button type="submit" className="btn-primary auth-submit" disabled={!canSubmit}>Continue</button>
            </form>

            <p className="auth-switch">
                Already have an account?{' '}
                <button type="button" className="auth-link" onClick={onShowLogin}>Log in</button>
            </p>
        </>
    );
}
